"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Sidebar = exports.SIDEBAR_TRANSITION_DURATION = void 0;
var React = __importStar(require("react"));
var Icon_1 = __importDefault(require("../Icon/Icon"));
// Please keep in sync with $menu-transition-duration variable in `client/scss/settings/_variables.scss`
exports.SIDEBAR_TRANSITION_DURATION = 150;
var Sidebar = function (_a) {
    var modules = _a.modules, currentPath = _a.currentPath, collapsedOnLoad = _a.collapsedOnLoad, strings = _a.strings, navigate = _a.navigate, onExpandCollapse = _a.onExpandCollapse;
    // 'collapsed' is a persistent state that is controlled by the arrow icon at the top
    // It records the user's general preference for a collapsed/uncollapsed menu
    // This is just a hint though, and we may still collapse the menu if the screen is too small
    // Also, we may display the full menu temporarily in collapsed mode (see 'peeking' below)
    var _b = __read(React.useState(collapsedOnLoad), 2), collapsed = _b[0], setCollapsed = _b[1];
    // Call onExpandCollapse(true) if menu is initialised in collapsed state
    React.useEffect(function () {
        if (collapsed && onExpandCollapse) {
            onExpandCollapse(true);
        }
    }, []);
    // 'peeking' is a temporary state to allow the user to peek in the menu while it is collapsed, or hidden.
    // When peeking is true, the menu renders as if it's not collapsed, but as an overlay instead of occupying
    // space next to the content
    var _c = __read(React.useState(false), 2), peeking = _c[0], setPeeking = _c[1];
    // 'visibleOnMobile' indicates whether the sidebar is currently visible on mobile
    // On mobile, the sidebar is completely hidden by default and must be opened manually
    var _d = __read(React.useState(false), 2), visibleOnMobile = _d[0], setVisibleOnMobile = _d[1];
    // Tracks whether the screen is below 800 pixels. In this state, the menu is completely hidden.
    // State is used here in case the user changes their browser size
    var checkWindowSizeIsMobile = function () { return window.innerWidth < 800; };
    var _e = __read(React.useState(checkWindowSizeIsMobile()), 2), isMobile = _e[0], setIsMobile = _e[1];
    React.useEffect(function () {
        function handleResize() {
            if (checkWindowSizeIsMobile()) {
                setIsMobile(true);
            }
            else {
                setIsMobile(false);
                // Close the menu as this state is not used in desktop
                setVisibleOnMobile(false);
            }
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    // Whether or not to display the menu with slim layout.
    // Separate from 'collapsed' as the menu can still be displayed with an expanded
    // layout while in 'collapsed' mode if the user is 'peeking' into it (see above)
    var slim = collapsed && !peeking && !isMobile;
    // 'expandingOrCollapsing' is set to true whilst the the menu is transitioning between slim and expanded layouts
    var _f = __read(React.useState(false), 2), expandingOrCollapsing = _f[0], setExpandingOrCollapsing = _f[1];
    React.useEffect(function () {
        setExpandingOrCollapsing(true);
        var finishTimeout = setTimeout(function () {
            setExpandingOrCollapsing(false);
        }, exports.SIDEBAR_TRANSITION_DURATION);
        return function () {
            clearTimeout(finishTimeout);
        };
    }, [slim]);
    var onClickCollapseToggle = function (e) {
        e.preventDefault();
        setCollapsed(!collapsed);
        if (onExpandCollapse) {
            onExpandCollapse(!collapsed);
        }
    };
    var onClickOpenCloseToggle = function (e) {
        e.preventDefault();
        setVisibleOnMobile(!visibleOnMobile);
        setExpandingOrCollapsing(true);
        var finishTimeout = setTimeout(function () {
            setExpandingOrCollapsing(false);
        }, exports.SIDEBAR_TRANSITION_DURATION);
        return function () {
            clearTimeout(finishTimeout);
        };
    };
    // Switch peeking on/off when the mouse cursor hovers the sidebar or focus is on the sidebar
    var _g = __read(React.useState(false), 2), mouseHover = _g[0], setMouseHover = _g[1];
    var _h = __read(React.useState(false), 2), focused = _h[0], setFocused = _h[1];
    var onMouseEnterHandler = function () {
        setMouseHover(true);
    };
    var onMouseLeaveHandler = function () {
        setMouseHover(false);
    };
    var onFocusHandler = function () {
        setFocused(true);
    };
    var onBlurHandler = function () {
        setFocused(false);
    };
    // We need a stop peeking timeout to stop the sidebar moving as someone tab's though the menu
    var stopPeekingTimeout = React.useRef(null);
    React.useEffect(function () {
        if (mouseHover || focused) {
            clearTimeout(stopPeekingTimeout.current);
            setPeeking(true);
        }
        else {
            clearTimeout(stopPeekingTimeout.current);
            stopPeekingTimeout.current = setTimeout(function () {
                setPeeking(false);
            }, exports.SIDEBAR_TRANSITION_DURATION);
        }
    }, [mouseHover, focused]);
    // Render modules
    var renderedModules = modules.map(function (module, index) { return module.render({
        key: index,
        slim: slim,
        expandingOrCollapsing: expandingOrCollapsing,
        currentPath: currentPath,
        strings: strings,
        navigate: navigate
    }); });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'sidebar'
                + (slim ? ' sidebar--slim' : '')
                + (isMobile ? ' sidebar--mobile' : '')
                + ((isMobile && !visibleOnMobile) ? ' sidebar--hidden' : '') },
            React.createElement("div", { className: "sidebar__inner" },
                React.createElement("button", { onClick: onClickCollapseToggle, "aria-label": strings.TOGGLE_SIDEBAR, "aria-expanded": !slim, className: "button sidebar__collapse-toggle" }, collapsed ? React.createElement(Icon_1["default"], { name: "angle-double-right" }) : React.createElement(Icon_1["default"], { name: "angle-double-left" })),
                React.createElement("div", { className: "sidebar__peek-hover-area", onMouseEnter: onMouseEnterHandler, onMouseLeave: onMouseLeaveHandler, onFocus: onFocusHandler, onBlur: onBlurHandler }, renderedModules))),
        React.createElement("button", { onClick: onClickOpenCloseToggle, "aria-label": strings.TOGGLE_SIDEBAR, "aria-expanded": visibleOnMobile, className: 'button sidebar-nav-toggle'
                + (isMobile ? ' sidebar-nav-toggle--mobile' : '')
                + (visibleOnMobile ? ' sidebar-nav-toggle--open' : '') }, visibleOnMobile ? React.createElement(Icon_1["default"], { name: "cross" }) : React.createElement(Icon_1["default"], { name: "bars" }))));
};
exports.Sidebar = Sidebar;
